/** Chuỗi của Pha D — kho, bán lẻ, sản phẩm. Tiếng Việt có dấu, câu ngắn. */
import { chuHienTai } from './theo-nganh.ts'

/** "-1250" → "−1.250" (số lượng nguyên, không phải tiền). */
function soDep(so: string): string {
  const am = so.startsWith('-')
  const tri = (am ? so.slice(1) : so).replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  return am ? `−${tri}` : tri
}
export const K = {
  tab: 'Kho',
  chuaCoSanPham: 'Tiệm chưa có sản phẩm nào.',
  chuaCoSanPhamPhu: 'Chủ tiệm thêm sản phẩm ở Cấu hình → Sản phẩm.',
  sapHet: 'Sắp hết',
  hetHang: 'Hết hàng',
  am: 'Âm kho, cần kiểm kê',
  amGiaiThich: 'Tồn âm: đã dùng / bán nhiều hơn số đã nhập. Kiểm kê để sửa số.',
  // Nhóm nghìn + dấu trừ thật (ui-critic v12: "-30 ml", "1000 ml").
  ton: (so: string, dv: string) => `${soDep(so)} ${dv}`,
  sapHetDauTrang: (n: number) => `${n} sản phẩm cần nhập thêm`,
  moCauHinhSp: 'Thêm sản phẩm',
  soKhoTrong: 'Chưa có lần nhập / dùng nào.',
  soKhoTrongPhu: 'Bấm "Nhập hàng" để ghi lần nhập đầu tiên.',
  lechXemTruoc: (lech: number, dv: string) =>
    lech === 0
      ? 'Khớp sổ, không lệch'
      : lech > 0
        ? `Dư ${soDep(String(lech))} ${dv} so với sổ`
        : `Thiếu ${soDep(String(-lech))} ${dv} so với sổ`,
  kiemKeHoiLai: 'Lưu số đếm này? Sổ kho ghi dòng điều chỉnh, không xoá được.',
  kiemKeThat: 'Lưu, ghi sổ',
  conTon: (so: string, dv: string) => `còn ${soDep(so)} ${dv}`,
  hetHangBan: 'hết hàng — vẫn bán được, nhớ nhập thêm',

  // Sổ kho một sản phẩm
  loai: {
    import: 'Nhập hàng',
    sale: 'Bán lẻ',
    consume: 'Dùng cho dịch vụ',
    adjust: 'Kiểm kê',
    reversal: 'Trả lại (huỷ hoá đơn)',
  } as Record<string, string>,
  hoaDon: (so: string) => `hoá đơn ${so}`,
  nhapHang: 'Nhập hàng',
  kiemKe: 'Kiểm kê',
  soLuongNhap: (dv: string) => `Số lượng nhập (${dv})`,
  giaNhap: (dv: string) => `Giá nhập một ${dv} (không bắt buộc)`,
  tongNhap: (tien: string) => `Tổng tiền nhập: ${tien}`,
  giaCao: (dv: string) => `Giá một ${dv} khá cao. Có phải bạn gõ giá cả chai hay cả hộp?`,
  tonHien: (so: string, dv: string) => `Tồn ${soDep(so)} ${dv}`,
  nhom: (so: string) => soDep(so),
  nhapNut: (so: string, dv: string) => `Nhập ${soDep(so)} ${dv}`,
  daNhap: (so: string, dv: string) => `Đã nhập ${soDep(so)} ${dv}`,
  demDuoc: (dv: string) => `Đếm thật được (${dv})`,
  lyDoKiemKe: 'ví dụ: đếm cuối tháng',
  kiemKeNut: 'Lưu số đếm',
  daKiemKe: (lech: string, dv: string) => `Đã kiểm kê · lệch ${lech} ${dv}`,
  khongLech: 'Đã kiểm kê · khớp sổ',
  ghiChuTuyChon: 'Ghi chú (không bắt buộc)',

  // Bán lẻ
  banLe: 'Bán lẻ',
  banLeTitle: 'Bán lẻ sản phẩm',
  chuaBanLe: 'Tiệm chưa có sản phẩm bán lẻ.',
  chuaBanLePhu: 'Nhập giá bán lẻ cho sản phẩm ở Cấu hình → Sản phẩm.',
  tongBanLe: 'Tổng',
  thuBanLe: (tien: string, cach: string) => `Thu ${tien} · ${cach.toLowerCase()}`,
  chonSanPham: 'Chọn sản phẩm để thu tiền',
  daBanLe: (so: string, tien: string) => `Đã bán lẻ ${tien} · hoá đơn ${so}`,
  bot: (ten: string) => `Bớt ${ten}`,
  them: (ten: string) => `Thêm ${ten}`,
  banKem: 'Bán kèm sản phẩm',

  // Cấu hình
  tabCauHinh: 'Sản phẩm',
  spTitle: 'Sản phẩm của tiệm',
  get spHint() {
    return chuHienTai().moTaSanPham
  },
  themSp: 'Thêm sản phẩm',
  suaSp: 'Sửa sản phẩm',
  tenSp: 'Tên sản phẩm',
  get tenSpGoiY() {
    return chuHienTai().viDuTenSanPham
  },
  donVi: 'Đơn vị',
  donViGoiY: 'ml, g, chai, cái…',
  giaBan: 'Giá bán lẻ (để trống nếu không bán)',
  canhBao: 'Báo sắp hết khi còn',
  dangDung: 'Đang dùng',
  luuSp: 'Lưu sản phẩm',
  daLuuSp: 'Đã lưu sản phẩm',
  dmTitle: 'Dùng bao nhiêu cho mỗi dịch vụ',
  dmHint: 'Làm xong dịch vụ và thu tiền, kho tự trừ đúng số này.',
  chonDv: 'Chọn dịch vụ',
  themDong: 'Thêm sản phẩm dùng',
  boDong: 'Bỏ dòng này',
  luuDm: 'Lưu định mức',
  daLuuDm: 'Đã lưu định mức',
  soLuong: 'Số lượng',
  chonSp: 'Chọn sản phẩm',
} as const
